import LargeComponent from './Navigation'
import SmallComponent from './SmallNavigation'
import WithResponsive from '../../hoc/WithResponsive'

export default WithResponsive(LargeComponent, SmallComponent)
